<template>
  <div v-if="shouldShow" class="d-flex align-start mb-4" data-testid="ticket-auto-close-notice">
    <v-icon size="24" icon="$warning" class="mr-2 auto-close-notice__icon" />
    <span class="body2" v-html="$t('ticketDetails.autoCloseNotice', { n: autoCloseDays })"></span>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import type { TicketDetails } from "@/_store/tickets/tickets.module";
import { AGGREGATED_DG_TICKET_AUTO_CLOSE_DAYS, TicketTrigger } from "@/constants/tickets";

export default defineComponent({
  props: {
    ticketDetails: {
      type: Object as PropType<TicketDetails>,
      required: true,
    },
  },
  setup(props) {
    const shouldShow = computed(
      () =>
        props.ticketDetails?.eventTrigger === TicketTrigger.DLP_DEVICE_SENSITIVE_DATA &&
        !props.ticketDetails?.processed
    );

    return {
      shouldShow,
      autoCloseDays: AGGREGATED_DG_TICKET_AUTO_CLOSE_DAYS,
    };
  },
});
</script>

<style lang="scss" scoped>
.auto-close-notice__icon {
  &.icon-warning-xs:before {
    color: rgb(var(--v-theme-primary));
  }
}
</style>
